var map = {
	"./arrow.svg": "5975",
	"./diameter.svg": "5639",
	"./distance.svg": "9dd0",
	"./earth.svg": "3187",
	"./jupiter.svg": "835a",
	"./lightspeed.svg": "f682",
	"./mars.svg": "769d",
	"./mercury.svg": "78b8",
	"./nav.svg": "d06c",
	"./neptune.svg": "a51b",
	"./plus.svg": "6cf9",
	"./pluto.svg": "95da",
	"./question.svg": "40d9",
	"./saturn.svg": "78a9",
	"./scale.svg": "21bb",
	"./sol.svg": "4a50",
	"./uranus.svg": "015a",
	"./venus.svg": "c820"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";